import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { HorizontalDividerComponent } from '@lassi/webapp-component';
import { RouteUtilsService } from '@lassi/webapp-shared';
import { AsTypePipe } from '@lassi/webapp-shared-pipes';
import { map } from 'rxjs';
import { DrawerTitle } from './drawer';

@Component({
  selector: 'lassi-drawer-component',
  imports: [
    RouterModule,
    MatIconModule,
    MatButtonModule,
    HorizontalDividerComponent,
    AsTypePipe,
  ],
  template: `
    <div class="heading">
      @if (back()) {
        <button
          mat-icon-button
          [routerLink]="back()"
          queryParamsHandling="preserve"
          aria-label="back"
        >
          <mat-icon> arrow_back</mat-icon>
        </button>
      }
      <h2 class="mat-label-large">
        <b>{{
          title() ??
            (outlet.isActivated
              ? (outlet.component | asType: DrawerTitle)?.drawerTitle?.()
              : '')
        }}</b>
      </h2>
      <button
        mat-icon-button
        [routerLink]="['..']"
        queryParamsHandling="preserve"
        data-testid="close-drawer-btn"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <lib-horizontal-divider class="divider"></lib-horizontal-divider>
    <div class="drawer-content">
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      height: 100%;
      padding: 0 1rem 1rem;

      .heading {
        flex-shrink: 0;
      }

      lib-horizontal-divider {
        margin-bottom: 1rem;
      }

      .drawer-content {
        flex: 1;
        min-height: 0;
      }
    }

    .heading {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 0.5rem;

      h2 {
        flex-grow: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;

        margin-block: 1.25rem;
      }

      :not(h2) {
        flex-shrink: 0;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerComponent {
  routeUtilsService = inject(RouteUtilsService);
  activatedRoute = inject(ActivatedRoute);

  DrawerTitle!: DrawerTitle;

  back = toSignal(
    this.routeUtilsService.leafRouteData$.pipe(map((data) => data.drawerBack)),
  );
  title = toSignal(
    this.routeUtilsService.leafRouteData$.pipe(map((data) => data.title)),
  );
}
